export enum InputTranslatorType {
  Text = 'text',
  WYSIWYG = 'wysiwyg',
}
